import React, { FC, useEffect } from 'react';

import { IGlobalState } from './global-state.interface';
import { useStore } from '@/store/';

const GlobalState: FC<IGlobalState> = ({ children, cartData, viewDefinitionResults, kamFlags, ldFlags }) => {
  const updateCartData = useStore(({ setCartData }) => setCartData);
  const updateViewDefinition = useStore(({ setViewDefinition }) => setViewDefinition);
  const updateKamFlags = useStore(({ setKamFlags }) => setKamFlags);
  const updateLdFlags = useStore(({ setLdFlags }) => setLdFlags);

  // wrapped in useEffect to avoid hydration errors
  useEffect(() => {
    updateCartData(cartData!);
    updateViewDefinition(viewDefinitionResults!);
    updateKamFlags(kamFlags || null);
    updateLdFlags(ldFlags || null);
  }, [cartData, viewDefinitionResults, kamFlags, ldFlags, updateCartData, updateViewDefinition, updateKamFlags, updateLdFlags]);

  return <>{children}</>;
};

export default GlobalState;
